// extracted by mini-css-extract-plugin
export default {"tabs":"JHwJ","tabs-toggle-style":"KJHk","tabsToggleStyle":"KJHk","divider":"NAXz"};